import { Component, EventEmitter, Output, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatMenuModule } from '@angular/material/menu';
import { RouterOutlet } from '@angular/router';
import { KeycloakService } from 'keycloak-angular';
import { MatBadgeModule } from '@angular/material/badge';
import { environment } from '../../../environments/environment';
import { NotificationsService } from '../../core/services/notifications.service';
import { CommonModule } from '@angular/common';
import { TranslationService } from '../../core/services/translation.service';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-navbar',
  standalone: true,
  imports: [
    RouterOutlet,
    MatToolbarModule,
    MatButtonModule,
    MatIconModule,
    MatMenuModule,
    MatBadgeModule,
    CommonModule,
    TranslateModule
  ],
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss']
})
export class NavbarComponent {
  private readonly keycloakService = inject(KeycloakService);
  private notificationService = inject(NotificationsService);
  private translationService = inject(TranslationService);

  @Output() toggleSidebarEvent = new EventEmitter<void>();

  get notifications() {
    return this.notificationService.getRequests();
  }

  get unreadCount() {
    return this.notificationService.getUnreadCount();
  }

  logout() {
    this.keycloakService.logout(window.location.origin);
  }

  toggleSidebar() {
    this.toggleSidebarEvent.emit();
  }

  markAllAsRead() {
    this.notificationService.markAllAsRead();
  }

  get environment() {
    return environment;
  }

  changeLanguage(lang: string) {
    this.translationService.changeLang(lang);
  }
}